export const Language = {
    FR: "fr"
}